<div class="chart-container" [ngClass]="{'mobile-ui': showMobileUi}">
    <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" type="line"> </canvas>
</div>
